const InputLinks = {
    //themeColor: '#2f8d99',
    main : [
        {id:1, link:'cm', icon:'receipt-cutoff', text:'COMMANDES', desc:''},
        {id:2, link:'mc', icon:'box2-heart-fill', text:'MES COMMANDES', desc:''},
        {id:3, link:'cg', icon:'folder2-open', text:'Mon Stock', desc:''},
        {id:4, link:'cg/familles', icon:'boxes', text:'Familles', desc:''},
        {id:5, link:'cl/ajouter', icon:'person-plus-fill', text:'Ajouter Client', desc:''},
        {id:6, link:'cl/recherche', icon:'search', text:'Recherche', desc:''},
        {id:7, link:'cl/pointage', icon:'geo-alt', text:'Pointage', desc:''},
        {id:8, link:'cl/List', icon:'person-lines-fill', text:'Liste Compléte', desc:''},  
        {id:9, link:'rt', icon:'currency-exchange', text:'Recette', desc:''},  
        {id:10, link:'stat', icon:'bar-chart-line', text:'Statistiques', desc:''},  
    ],

    //return back card 
    backCard:{
        nv : {id:1, text:'Nouveaux Commande', link:'/C'},
        pan : {id:1, text:'Pannier', link:'/C'},

        cl : {id:2, text:'Client Info', link:'/C/clist'},
        clAdd : {id:3, text:'Ajouter Client', link:'/C'},
        clPtg : {id:4, text:'Pointage des Clients', link:'/C'},
        clMap : {id:5, text:'Recherche des Clients', link:'/C'},
        clList : {id:6, text:'Liste des Clients', link:'/C'},

        mc : {id:7, text:'Mes Commandes', link:'/C'},
        mcInfo : {id:8, text:'Commande Info', link:'/C'},
        mcInfo : {id:9, text:'Modifier Commande', link:'/C'},

        cg : {id:10, text:'Catalogue', link:'/C'},
        cgList : {id:11, text:'Liste des Articles', link:'/C'},
        cgFamille : {id:12, text:'Liste des Familles', link:'/C'},
        cgInfo : {id:13, text:'Info Sur Article', link:'/C'},
        cgPhoto: {id:14, text:'Ajoiuter Photo', link:'/C'},

        up: {id:15, text:'Mettre A jour', link:'/C'},
        rt: {id:15, text:'Resumer', link:'/C'},
        stat: {id:15, text:'Statistique', link:'/C'},
    }
}
export default InputLinks